// src/lib/locale.ts
import headerNavbarEn from "@/locales/en_US/headerNavbar.json" with { type: "json" }
import headerNavbarVi from "@/locales/vi_VN/headerNavbar.json" with { type: "json" }
import heroEn from "@/locales/en_US/hero.json" with { type: "json" }
import heroVi from "@/locales/vi_VN/hero.json" with { type: "json" }
import secondHeroEn from "@/locales/en_US/secondHero.json" with { type: "json" }
import secondHeroVi from "@/locales/vi_VN/secondHero.json" with { type: "json" }
import promoBannerEn from "@/locales/en_US/promoBanner.json" with { type: "json" }
import promoBannerVi from "@/locales/vi_VN/promoBanner.json" with { type: "json" }
import videoHeroEn from "@/locales/en_US/videoHero.json" with { type: "json" }
import videoHeroVi from "@/locales/vi_VN/videoHero.json" with { type: "json" }
import navbarEn from "@/locales/en_US/navbar.json" with { type: "json" }
import navbarVi from "@/locales/vi_VN/navbar.json" with { type: "json" }
import commonEn from "@/locales/en_US/common.json" with { type: "json" }
import commonVi from "@/locales/vi_VN/common.json" with { type: "json" }
import authEn from "@/locales/en_US/auth.json" with { type: "json" }
import authVi from "@/locales/vi_VN/auth.json" with { type: "json" }
import navigationEn from "@/locales/en_US/navigation.json" with { type: "json" }
import navigationVi from "@/locales/vi_VN/navigation.json" with { type: "json" }
import topbarEn from "@/locales/en_US/topbar.json" with { type: "json" }
import topbarVi from "@/locales/vi_VN/topbar.json" with { type: "json" }
import locationEn from "@/locales/en_US/location.json" with { type: "json" }
import locationVi from "@/locales/vi_VN/location.json" with { type: "json" }
import feedbackEn from "@/locales/en_US/feedback.json" with { type: "json" }
import feedbackVi from "@/locales/vi_VN/feedback.json" with { type: "json" }
import accountEn from "@/locales/en_US/account.json" with { type: "json" }
import accountVi from "@/locales/vi_VN/account.json" with { type: "json" }
import productEn from "@/locales/en_US/product.json" with { type: "json" }
import productVi from "@/locales/vi_VN/product.json" with { type: "json" }
import mobileEn from "@/locales/en_US/mobile.json" with { type: "json" }
import mobileVi from "@/locales/vi_VN/mobile.json" with { type: "json" }
import footerEn from "@/locales/en_US/footer.json" with { type: "json" }
import footerVi from "@/locales/vi_VN/footer.json" with { type: "json" }
import megaMenuEn from "@/locales/en_US/mega-menu.json" with { type: "json" }
import megaMenuVi from "@/locales/vi_VN/mega-menu.json" with { type: "json" }
import productListEn from "@/locales/en_US/product-list.json" with { type: "json" }
import productListVi from "@/locales/vi_VN/product-list.json" with { type: "json" }
import filterEn from "@/locales/en_US/filter.json" with { type: "json" }
import filterVi from "@/locales/vi_VN/filter.json" with { type: "json" }
import productDetailEn from "@/locales/en_US/product-detail.json" with { type: "json" }
import productDetailVi from "@/locales/vi_VN/product-detail.json" with { type: "json" }
import categoryPagesEn from "@/locales/en_US/category-pages.json" with { type: "json" }
import categoryPagesVi from "@/locales/vi_VN/category-pages.json" with { type: "json" }
import storesEn from "@/locales/en_US/stores.json" with { type: "json" }
import storesVi from "@/locales/vi_VN/stores.json" with { type: "json" }
import homeEn from "@/locales/en_US/home.json" with { type: "json" }
import homeVi from "@/locales/vi_VN/home.json" with { type: "json" }
import pageFooterEn from "@/locales/en_US/page-footer.json" with { type: "json" }
import pageFooterVi from "@/locales/vi_VN/page-footer.json" with { type: "json" }
import chatEn from "@/locales/en_US/chat.json" with { type: "json" }
import chatVi from "@/locales/vi_VN/chat.json" with { type: "json" }
import commerceEn from "@/locales/en_US/commerce.json" with { type: "json" }
import commerceVi from "@/locales/vi_VN/commerce.json" with { type: "json" }
import sizeGuideEn from "@/locales/en_US/size-guide.json" with { type: "json" }
import sizeGuideVi from "@/locales/vi_VN/size-guide.json" with { type: "json" }

export const locales = {
  "en_US": {
    navbar: navbarEn,
    headerNavbar: headerNavbarEn,
    hero: heroEn,
    secondHero: secondHeroEn,
    promoBanner: promoBannerEn,
    videoHero: videoHeroEn,
    common: commonEn,
    auth: authEn,
    navigation: navigationEn,
    topbar: topbarEn,
    location: locationEn,
    feedback: feedbackEn,
    account: accountEn,
    product: productEn,
    mobile: mobileEn,
    footer: footerEn,
    megaMenu: megaMenuEn,
    productList: productListEn,
    filter: filterEn,
    productDetail: productDetailEn,
    categoryPages: categoryPagesEn,
    stores: storesEn,
    home: homeEn,
    pageFooter: pageFooterEn,
    chat: chatEn,
    commerce: commerceEn,
    sizeGuide: sizeGuideEn,
  },
  "vi_VN": {
    navbar: navbarVi,
    headerNavbar: headerNavbarVi,
    hero: heroVi,
    secondHero: secondHeroVi,
    promoBanner: promoBannerVi,
    videoHero: videoHeroVi,
    common: commonVi,
    auth: authVi,
    navigation: navigationVi,
    topbar: topbarVi,
    location: locationVi,
    feedback: feedbackVi,
    account: accountVi,
    product: productVi,
    mobile: mobileVi,
    footer: footerVi,
    megaMenu: megaMenuVi,
    productList: productListVi,
    filter: filterVi,
    productDetail: productDetailVi,
    categoryPages: categoryPagesVi,
    stores: storesVi,
    home: homeVi,
    pageFooter: pageFooterVi,
    chat: chatVi,
    commerce: commerceVi,
    sizeGuide: sizeGuideVi,
  },
} as const

export type Locale = keyof typeof locales
export type Namespace = keyof typeof locales[Locale]
export type TranslationKey<N extends Namespace> = keyof typeof locales[Locale][N]
